module.exports = __webpack_public_path__ + "img/HZ-P6011.8f4ad8c9.jpg";